export interface Avatars {
  [size: string]: string;
}

export function avatarsFromAvatarUrl(avatarUrl: string): Avatars {
  return ['30', '50', '170', 'original'].reduce((avatars: Avatars, size) => {
    avatars[size] = `${avatarUrl}/${size}.png`;
    return avatars;
  }, {});
}
